import { Text } from "@mantine/core";

export const ForbiddenPage = (): JSX.Element => {
    return (
        <div className="h-full flex flex-col justify-center items-center">
            <Text size="lg" fw={700}>
                Pro tuto akci nemáte oprávnění, nebo vypršelo vaše přihlášení
            </Text>
        </div>
    );
};
